import { Card, Container } from 'reactstrap';
import { BaseLoader } from './parts/BaseLoader';
import TeacherAttendanceTable from './parts/TeacherAttendanceTable';
import SearchControls from './parts/SearchControls';
import { TeacherAttendanceLoader } from './parts/TeacherAttendanceLoader';

export default function ClassTeacherAttendance() {
  return (
    <Card className="m-3 py-4">
      <Container fluid>
        <BaseLoader>
          {() => (
            <TeacherAttendanceLoader>
              <>
                <SearchControls />
                <TeacherAttendanceTable />
              </>
            </TeacherAttendanceLoader>
          )}
        </BaseLoader>
      </Container>
    </Card>
  );
}
